import { useTranslation } from "react-i18next";
import s from "./copyrightsText.module.scss";

const CopyRightsText = () => {
  const developerProfile = "";
  const designerProfile = "";
  const copyRightTrans = "footer.copyRightsText";
  const { t } = useTranslation();

  return (
    <p className={s.copyRights}>
      <span>{t(`${copyRightTrans}.designedBy`)}</span>
      <a href="#">Weepoka</a>
    </p>
  );
};
export default CopyRightsText;
